// import { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import logo from '../../assets/images/cherryhills.png';

// const Navbar = () => {
//   const [scrolled, setScrolled] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const location = useLocation();

//   const isHomePage = location.pathname === '/';
//   const isTransparent = isHomePage && !scrolled;

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 50);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navLinks = [
//     { name: 'What We Do', path: '/services' },
//     { name: 'Who We Are', path: '/about' },
//     { name: 'Resources', path: '/insights' },
//     { name: 'Testimonials', path: '/testimonials' },
//     { name: 'Contact', path: '/contact' },
//   ];

//   return (
//     <nav
//       className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
//         isTransparent ? 'bg-white/10 backdrop-blur-md' : 'bg-white shadow-md'
//       }`}
//     >
//       <div className="max-w-7xl mx-auto px-6 lg:px-8">
//         <div className="flex items-center justify-between h-20">
//           <Link to="/" className="flex items-center space-x-3">
//             <img
//               src={logo}
//               alt="Cherryhills Logo"
//               className="h-12 w-18"
//             />
//             {/* <span className={`text-xl font-semibold transition-colors ${isTransparent ? 'text-white' : 'text-primary-dark'}`}>
//               Cherryhills
//             </span> */}
//             <span className="text-lg font-semibold">
//               <span className="text-orange-500">Cherry</span>{" "}
//               <span className={`text-xl font-semibold transition-colors ${isTransparent ? 'text-white' : 'text-green-600'}`}>Hills</span>
//             </span>
//           </Link>

//           <div className="hidden md:flex items-center space-x-8">
//             {navLinks.map((link) => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className={`text-sm font-medium transition-colors whitespace-nowrap ${
//                   location.pathname === link.path
//                     ? isTransparent
//                       ? 'text-white'
//                       : 'text-primary-orange'
//                     : isTransparent
//                     ? 'text-white/90 hover:text-white'
//                     : 'text-gray-700 hover:text-primary-orange'
//                 }`}
//               >
//                 {link.name}
//               </Link>
//             ))}
            
//             <Link
//               to="/contact"
//               className="px-6 py-2.5 bg-primary-orange text-white text-sm font-medium rounded-full hover:bg-primary-orange/90 transition-all whitespace-nowrap cursor-pointer"
//             >
//               Get Started
//             </Link>
//           </div>

//           <button
//             className="md:hidden"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             aria-label="Toggle menu"
//           >
//             <i className={`ri-menu-line text-2xl ${isTransparent ? 'text-white' : 'text-primary-dark'}`}></i>
//           </button>
//         </div>
//       </div>

//       {mobileMenuOpen && (
//         <div className="md:hidden bg-white shadow-lg">
//           <div className="px-6 py-4 space-y-3">
//             {navLinks.map((link) => (
//               <Link
//                 key={link.path}
//                 to={link.path}
//                 className="block text-gray-700 hover:text-primary-orange transition-colors"
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 {link.name}
//               </Link>
//             ))}
//             <Link
//               to="/dashboard"
//               className="block px-6 py-2.5 bg-primary-green text-white text-center rounded-full hover:bg-primary-green/90 transition-all cursor-pointer"
//               onClick={() => setMobileMenuOpen(false)}
//             >
//               Client Portal
//             </Link>
//             <Link
//               to="/contact"
//               className="block px-6 py-2.5 bg-primary-orange text-white text-center rounded-full hover:bg-primary-orange/90 transition-all cursor-pointer"
//               onClick={() => setMobileMenuOpen(false)}
//             >
//               Get Started
//             </Link>
//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;








import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion'; // Added for animations
import logo from '../../assets/chil.png';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isHomePage = location.pathname === '/';
  const isTransparent = isHomePage && !scrolled;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'What We Do', path: '/services' },
    { name: 'Who We Are', path: '/about' },
    { name: 'Resources', path: '/insights' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isTransparent 
          ? 'bg-white backdrop-blur-md py-4' 
          : 'bg-white shadow-xl shadow-black/5 py-3'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo Section */}
          <Link to="/" className="flex items-center space-x-2 group">
            <motion.img
              whileHover={{ rotate: -5, scale: 1.05 }}
              src={logo}
              alt="Cherryhills Logo"
              className="h-16 w-auto"
            />
           
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-semibold transition-colors py-2 group whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'text-primary-orange'
                    : 'text-gray-600 hover:text-primary-orange'
                }`}
              >
                {link.name}
                {/* Animated Underline */}
                <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-primary-orange transform scale-x-0 origin-center transition-transform duration-300 ease-out group-hover:scale-x-100 ${location.pathname === link.path ? 'scale-x-100' : ''}`} />
              </Link>
            ))}
            
            <Link
              to="/contact"
              className="relative overflow-hidden px-7 py-2.5 bg-primary-orange text-white text-sm font-bold rounded-full transition-all duration-300 hover:bg-primary-dark hover:shadow-lg hover:shadow-primary-orange/20 active:scale-95"
            >
              <span className="relative z-10">Get Started</span>
            </Link>
          </div>

          {/* Mobile Toggle */}
          <button
            className="md:hidden p-2 rounded-lg bg-gray-50"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-4-fill'} text-primary-dark`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <motion.div 
        initial={false}
        animate={mobileMenuOpen ? { height: 'auto', opacity: 1 } : { height: 0, opacity: 0 }}
        className="md:hidden bg-white border-t border-gray-100 overflow-hidden"
      >
        <div className="px-6 py-8 space-y-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className="block text-lg font-medium text-gray-800 hover:text-primary-orange transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.name}
            </Link>
          ))}
          <div className="pt-4 border-t border-gray-50 flex flex-col gap-4">
             <Link
              to="/contact"
              className="w-full py-4 bg-primary-orange text-white text-center font-bold rounded-xl shadow-lg"
              onClick={() => setMobileMenuOpen(false)}
            >
              Get Started
            </Link>
          </div>
        </div>
      </motion.div>
    </motion.nav>
  );
};

export default Navbar;
